@if (licenseUpgradePurchaseFlagOn) {
  @if (license$ | async; as license) {
    <!-- Do not show this breadcrumb while license expiration breadcrumb is shown -->
    @if (!licenseExpirationHandler.isExpiringLicenseRequiringWarning(license)) {
      @if (shouldShowBadge(license)) {
        <license-plan-badge
          class="license-plan-badge-breadcrumb"
          [loading]="loading$ | async"
          [license]="license"
          (actionClick)="licensePlanBadgeClicked(license)"
          [hideAction]="!!license.salesforce_license?.has_renewal"
          >
        </license-plan-badge>
      }
    }
  }
}
